<script>
  import { Col, Container, Row } from 'sveltestrap';
  import Card from './Card.svelte';

  let dateStart = new Date(2012, 6, 1);
  let currDate = new Date();

  function monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  let totalYears = Math.round(monthDiff(dateStart, currDate) / 6)/2;

  import SwiperCore, { Pagination, A11y, Autoplay } from 'swiper';
  import { Swiper, SwiperSlide } from 'swiper/svelte';
  import 'swiper/swiper-bundle.min.css';

  SwiperCore.use([Pagination, A11y, Autoplay]);
</script>

<style>
  .wrapper {
    padding-top: 50px;
    padding-bottom: 25px;
  }

  .stats {
    color: var(--palette-grad1);
  }

  .outer {
    width: 100%;
    background-color: var(--bgcolor);
    background-image: var(--bgimage);
    position: relative;
  }

  .outer::before {
    background-color: var(--bgcolor);
    content: "";
    position: absolute;
    left: 0; right: 0;
    top: 0; bottom: 0;
  }

  :global(.swiper-container-horizontal > .swiper-pagination-bullets) {
    bottom: 0px !important;
  }

  .button {
    display: inline-block;
    margin-top: 25px;
    padding: 5px 15px 5px 15px;
    font-size: 12px;
    transition: all 0.4s;
    background-color: var(--palette-grad1);
    color: white !important;
  }

  .button:hover {
    background-color: var(--palette-grad3);
    color: var(--palette-grad2) !important;
  }
</style>

<span id="whativedone"></span>
<div class="outer" style="--bgcolor: white; padding-bottom: 50px">
  <Container>
    <Row>
      <Col xs="12">
        <div class="wrapper">
          <div class="handwriting">What I've DONE</div>
          <div class="heading">HIGHLIGHTED PROJECTS</div>
          <a href="Micael_Axestal_CV_20210328.pdf" class="button" role="button" target="_new">DOWNLOAD RESUME →</a>
        </div>
      </Col>
    </Row>
    <Row>
      <Col xs="12">
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          autoplay
          pagination={{ clickable: true }}
        >
          <SwiperSlide>
            <Card tags={["FPGA", "Yocto", "CAN", "C", "AXI", "Zynq Ultrascale+", "serial", "video", "tcl", "bash", "make", "LaTeX"]}>
              <span slot="company">BAE SYSTEMS</span>
              <span slot="role">SW/FPGA DEVELOPER/ARCHITECT</span>
              <span slot="title">Video & communication unit</span>
              <span slot="date">201609 - 201704</span>
              <span slot="description">
                Pre-study and implementation of a replacement electronics unit for a combat vehicle. The product
                contained multiple video inputs and outputs with overlay and routing, multiple serial interfaces,
                GPIO, timers, CAN, BIT and watchdog.
                Pre-study responsibilities focused on the systemization of the software and software architecture,
                finding certain suitable hardware components as well as part of the test plan and system
                architecure.
              </span>
            </Card>
          </SwiperSlide>
          <SwiperSlide>
            <Card tags={["C", "CAN", "PTP", "GNSS", "Linux", "eCos", "PowerPC"]}>
              <span slot="company">VOLVO CAR CORPORATION</span>
              <span slot="role">SW DEVELOPER / ARCHITECT</span>
              <span slot="title">CAN - ethernet gateway</span>
              <span slot="date">201501 - 201606</span>
              <span slot="description">
                Produced and implemented the system software architecture for a gateway primarily
                between ethernet and CAN for use in one of VCCs Autonomous Drive projects. A GNSS-receiver together
                with PTP was used inside the gateway to synchronize the time with other units in the internal
                network and to timestamp each CAN-frame for logging and re-simulation purposes.
              </span>
            </Card>
          </SwiperSlide>
          <SwiperSlide>
            <Card tags={["VHDL", "Zynq", "SPI", "C", "Linux", "Petalinux"]}>
              <span slot="company">VOLVO CAR CORPORATION</span>
              <span slot="role">FPGA/SW DEVELOPER/ARCHITECT</span>
              <span slot="title">IMU simulators</span>
              <span slot="date">2016-07 - 2016-12 & 201801 - 201808</span>
              <span slot="description">
                Simulators implemented in FPGAs of Inertial Measurement Units for use in a Hardware In the Loop rig.
                Simulated accelerometer and gyroscope data was fed via ethernet from the rig software into the unit
                which emulated the specific IMU SPI-protocol and injected the values into the SPI-stream which was fed into
                a hardware SPI-master. The Linux part on the PS-system was responsible for ethernet communcation while the
                VHDL-implementation on the PL-part handled all SPI-communication.
              </span>
            </Card>
          </SwiperSlide>
          <SwiperSlide>
            <Card tags={["C#", "CAN", "C", "Linux", "Windows Embedded", "NTP", "GPS", "RTK"]}>
              <span slot="company">VCC, Autoliv, SAFER</span>
              <span slot="role">SW DEVELOPER/SYSTEM RESPONSIBLE</span>
              <span slot="title">Data loggers for FOTs</span>
              <span slot="date">201304 - 201412</span>
              <span slot="description">
                Part of multiple Field Operational Tests including DriveC2X and EyesOnRoad where data was collected from
                both video cameras as well as internal vehicle signals to mainly evaluate how regular everyday driving was
                affected by new ADAS-systems. Responsible for the logging system where all data was timestamped and
                synchronized with a GPS-receiver and stored. Included work both in Sweden, Finland as well as China.
              </span>
            </Card>
          </SwiperSlide>
      </Swiper>


      </Col>
        <!-- <div class="stats">
          Years in business: {totalYears}
          Automotive:
          Defence:
          Energy:
          Industry:
          Other:
        </div> -->
    </Row>
  </Container>
</div>
